

import { useMemo } from 'react'

import { DriverContext } from '@/shared/components/DriverTour/DriverContext'
import { useDriver } from '@/shared/components/DriverTour/libs/useDriver'

export const GlobalDriverProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { 
    driverInstance,
    startTour,
    moveToNextStep,
    getTourState,
    setSteps,
    setConfig,
  } = useDriver({
    initialSteps: [],
  })

  const contextValue = useMemo(() => ({
    driverInstance,
    startTour,
    moveToNextStep,
    getTourState,
    setSteps,
    setConfig,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [driverInstance, startTour])

  return (
    <DriverContext.Provider value={contextValue}>
      {children}
    </DriverContext.Provider>
  )
}
